"use strict";

var __createBinding = Object.create ? function (e, t, i, r) {
  void 0 === r && (r = i), Object.defineProperty(e, r, {
    enumerable: !0,
    get: function get() {
      return t[i];
    }
  });
} : function (e, t, i, r) {
  e[r = void 0 === r ? i : r] = t[i];
},
    __setModuleDefault = Object.create ? function (e, t) {
  Object.defineProperty(e, "default", {
    enumerable: !0,
    value: t
  });
} : function (e, t) {
  e.default = t;
},
    __importStar = function __importStar(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (null != e) for (var i in e) {
    "default" !== i && Object.hasOwnProperty.call(e, i) && __createBinding(t, e, i);
  }
  return __setModuleDefault(t, e), t;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isClonedItem = exports.isTargetItem = exports.isActiveItem = exports.getRenderStageItemClasses = void 0;

var Utils = __importStar(require(".")),
    types_1 = require("../types");

exports.getRenderStageItemClasses = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.fadeoutAnimationIndex,
      r = exports.isActiveItem(e, t) ? types_1.Modifiers.ACTIVE : "",
      n = exports.isClonedItem(e, t) ? types_1.Modifiers.CLONED : "",
      t = exports.isTargetItem(e, t) ? types_1.Modifiers.TARGET : "",
      i = e === i ? types_1.Classnames.ANIMATED : "";
  return Utils.concatClassnames(types_1.Classnames.STAGE_ITEM, r, n, t, i);
}, exports.isActiveItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.activeIndex,
      r = t.itemsInSlide,
      n = t.itemsOffset,
      s = t.infinite,
      o = t.autoWidth,
      t = Utils.getShiftIndex(r, n);
  if (o && s) return e - t === i + n;
  t = i + t;
  return s ? t <= e && e < t + r : i <= e && e < t;
}, exports.isTargetItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.activeIndex,
      r = t.itemsInSlide,
      n = t.itemsOffset,
      s = t.infinite,
      t = t.autoWidth,
      r = Utils.getShiftIndex(r, n);
  return s ? t && s ? e - r === i + n : e === i + r : e === i;
}, exports.isClonedItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.itemsInSlide,
      r = t.itemsOffset,
      n = t.itemsCount,
      s = t.infinite,
      t = t.autoWidth;
  if (!s) return !1;
  if (t && s) return e < i || n - 1 + i < e;
  r = Utils.getShiftIndex(i, r);
  return e < r || n - 1 + r < e;
};